export default () => {

  const cookieValue = document.cookie.split('; ').find(row => row.startsWith('cookies-hide='));
  if(!cookieValue) {
    document.querySelector('.cookies-hide') && document.querySelector('.cookies-hide').classList.remove('hidden');
  }

  document.querySelector('.cookies-hide') && document.querySelector('.cookies-hide__close').addEventListener('click', () => {
    document.querySelector('.cookies-hide').classList.add('not-showing');
    let date = new Date(Date.now() + 2678400e3);
    date = date.toUTCString();

    document.cookie = 'cookies-hide=1;expires=' + date;
  });
}




// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/esm/cookies-hide.js